"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchChargeafterUi = void 0;
var tslib_1 = require("tslib");
var initialize_1 = require("./initialize");
var launchChargeafterUi = function (_a) {
    var config = _a.config, onConfirm = _a.onConfirm, onApprovalStatusChange = _a.onApprovalStatusChange, checkout = _a.checkout, applicationId = _a.applicationId, cartDetails = _a.cartDetails, onDataUpdate = _a.onDataUpdate, onModalOpen = _a.onModalOpen, base = tslib_1.__rest(_a, ["config", "onConfirm", "onApprovalStatusChange", "checkout", "applicationId", "cartDetails", "onDataUpdate", "onModalOpen"]);
    return new Promise(function (resolve, reject) {
        var baseOpt = tslib_1.__assign({ channel: config.channel, preferences: config.preferences, onConfirm: onConfirm, onApprovalStatusChange: onApprovalStatusChange, browserSessionId: config.env.browserSessionId }, base);
        var checkoutOpt = tslib_1.__assign(tslib_1.__assign({}, baseOpt), { cartDetails: cartDetails, applicationId: applicationId, onDataUpdate: onDataUpdate
                ? function (updatedData, callback) {
                    var result = onDataUpdate(updatedData);
                    if (result)
                        result.then(function (data) { return callback(data); });
                    else
                        callback({});
                }
                : undefined, callback: function (token, data, error) {
                if (error) {
                    console.info("[ChargeAfterSDK]payments status: ".concat(JSON.stringify(error)));
                    reject(tslib_1.__assign(tslib_1.__assign({}, error), { data: data }));
                }
                else
                    resolve(tslib_1.__assign({ token: token }, data));
            } });
        var applyOpt = tslib_1.__assign(tslib_1.__assign({}, baseOpt), { callback: function (result, error) {
                if (error) {
                    console.info("[ChargeAfterSDK]payments status: ".concat(JSON.stringify(error)));
                    reject(tslib_1.__assign(tslib_1.__assign({}, error), { data: result }));
                }
                else
                    resolve(result);
            } });
        var caConfig = {
            apiKey: config.env.apiKey,
            delegatedMerchantId: config.env.delegatedMerchantId,
            storeId: config.storeId,
            onLoaded: onModalOpen,
        };
        (0, initialize_1.initialize)(caConfig, config.env.name).then(function (ChargeAfter) {
            var method = checkout ? 'checkout' : 'apply';
            console.log("Calling SDK for ".concat(method).concat(checkout ? ", resume token: '".concat(checkoutOpt.applicationId) : '', "'"));
            checkout
                ? ChargeAfter === null || ChargeAfter === void 0 ? void 0 : ChargeAfter.payments.present('checkout', checkoutOpt)
                : ChargeAfter === null || ChargeAfter === void 0 ? void 0 : ChargeAfter.payments.present('apply', applyOpt);
        });
    });
};
exports.launchChargeafterUi = launchChargeafterUi;
